export const STOREFRONT_LANGUAGES = [
  { code: 'tr', labelKey: 'languages.tr', flag: '🇹🇷', shortCode: 'TR' },
  { code: 'en', labelKey: 'languages.en', flag: '🇬🇧', shortCode: 'EN' },
  { code: 'de', labelKey: 'languages.de', flag: '🇩🇪', shortCode: 'DE' },
  { code: 'ar', labelKey: 'languages.ar', flag: '🇸🇦', shortCode: 'AR' },
  { code: 'ru', labelKey: 'languages.ru', flag: '🇷🇺', shortCode: 'RU' }
];

export const STOREFRONT_LANGUAGE_CODES = STOREFRONT_LANGUAGES.map((lang) => lang.code);

export const DEFAULT_ENABLED_LANGUAGES = [...STOREFRONT_LANGUAGE_CODES];

export const DEFAULT_STOREFRONT_LANGUAGE = 'tr';

export const DEFAULT_PRODUCT_NAMES = {
  tr: '',
  en: '',
  de: '',
  ar: '',
  ru: ''
};

export const normalizeLanguageCode = (code) => {
  const value = String(code || '').trim().toLowerCase().split('-')[0];
  return STOREFRONT_LANGUAGE_CODES.includes(value) ? value : '';
};

export const normalizeEnabledLanguages = (languages) => {
  if (!Array.isArray(languages)) return [...DEFAULT_ENABLED_LANGUAGES];
  const normalized = languages
    .map(normalizeLanguageCode)
    .filter((code, index, list) => code && list.indexOf(code) === index);
  return normalized.length > 0 ? normalized : [...DEFAULT_ENABLED_LANGUAGES];
};

export const normalizeDefaultLanguage = (language, enabledLanguages = DEFAULT_ENABLED_LANGUAGES) => {
  const normalized = normalizeLanguageCode(language);
  if (normalized && enabledLanguages.includes(normalized)) return normalized;
  if (enabledLanguages.includes(DEFAULT_STOREFRONT_LANGUAGE)) return DEFAULT_STOREFRONT_LANGUAGE;
  return enabledLanguages[0] || DEFAULT_STOREFRONT_LANGUAGE;
};

export const normalizeProductNames = (names = {}, fallbackName = '') => {
  const normalized = { ...DEFAULT_PRODUCT_NAMES };
  STOREFRONT_LANGUAGE_CODES.forEach((code) => {
    normalized[code] = String(names?.[code] || '').trim();
  });
  if (!normalized.tr && fallbackName) {
    normalized.tr = String(fallbackName).trim();
  }
  return normalized;
};

export const getLocalizedProductName = (product, lang = DEFAULT_STOREFRONT_LANGUAGE) => {
  const code = normalizeLanguageCode(lang) || DEFAULT_STOREFRONT_LANGUAGE;
  const names = product?.names || {};
  return names[code] || names.tr || product?.name || product?.displayName || '';
};

export const getLanguageMeta = (code) =>
  STOREFRONT_LANGUAGES.find((lang) => lang.code === code) || STOREFRONT_LANGUAGES[0];

export const getActiveLanguages = (enabledLanguages) => {
  const enabled = normalizeEnabledLanguages(enabledLanguages);
  return STOREFRONT_LANGUAGES.filter((lang) => enabled.includes(lang.code));
};

export const applyStorefrontLanguage = (lang, enabledLanguages = DEFAULT_ENABLED_LANGUAGES) => {
  const enabled = normalizeEnabledLanguages(enabledLanguages);
  const normalized = normalizeLanguageCode(lang);
  const resolved = normalized && enabled.includes(normalized)
    ? normalized
    : normalizeDefaultLanguage(DEFAULT_STOREFRONT_LANGUAGE, enabled);

  if (typeof document !== 'undefined') {
    document.documentElement.lang = resolved;
    document.documentElement.dir = resolved === 'ar' ? 'rtl' : 'ltr';
  }

  return resolved;
};
